module.exports = __webpack_public_path__ + "img/purple-logo.cc74cea1.svg";